import React from "react";
import { AccountTable } from "./styles"

export default props => {
    return (
        <AccountTable
            size="middle"
            columns={props.columns}
            rowKey={record => record.id}
            dataSource={props.dataSource}
            pagination={props.pagination}
            loading={props.loading}
            onChange={props.onChange}
            locale={{ emptyText: 'Sem dados' }}
            unsetRowHover={props.unsetRowHover}
        />
    )
}

